import { render, staticRenderFns } from "./CamSide.vue?vue&type=template&id=27f39734&"
import script from "./CamSide.vue?vue&type=script&lang=js&"
export * from "./CamSide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports